import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

// interface
import { ChatUserTypes } from '../../../data/chat';
import { STATUS_TYPES } from '../../../constants';

interface ChatUserProps {
    user: ChatUserTypes;
    selectedPersonChat: string | number;
    onSelectChat: (personId: number | string, conversationId: string) => void;
}
const ChatUser = React.forwardRef(
    (
        { user, selectedPersonChat, onSelectChat }: ChatUserProps,
        ref: React.ForwardedRef<HTMLLIElement>
    ) => {
        const displayName =
            user.person.displayName ||
            `${user.person.firstName} ${user.person.lastName}`;
        const shortName = `${user.person.firstName.charAt(0)}${user.person.lastName.charAt(0)}`;

        /* const colors = [
            'bg-primary',
            'bg-danger',
            'bg-info',
            'bg-warning',
            'bg-secondary',
            'bg-pink',
            'bg-purple'
        ]; */
        /* const [color] = useState(Math.floor(Math.random() * colors.length)); */
        const isOnline = user.status && user.status === STATUS_TYPES.ACTIVE;
        const unRead = user.newMessages;

        const isSelectedChat: boolean =
            selectedPersonChat && selectedPersonChat === user.personId
                ? true
                : false;
        const onClick = () => {
            onSelectChat(user.personId, user.conversationId);
        };
        const chatUserContent = (
            <Link to="#" className={classnames({ 'unread-msg-user': unRead })}>
                <div className="d-flex align-items-center">
                    <div
                        className={classnames(
                            'chat-user-img',
                            'align-self-center',
                            'me-2',
                            'ms-0',
                            { online: isOnline }
                        )}
                    >
                        {user.person.profileImage ? (
                            <>
                                <img
                                    src={user.person.profileImage}
                                    className="rounded-circle avatar-xs"
                                    alt=""
                                />
                                {isOnline && (
                                    <span className="user-status"></span>
                                )}
                            </>
                        ) : (
                            <div className="avatar-xs">
                                <span
                                    className={classnames(
                                        'avatar-title',
                                        'rounded-circle',
                                        'text-uppercase',
                                        'text-white',
                                        'bg-secondary'
                                    )}
                                >
                                    <span className="username">
                                        {shortName}
                                    </span>
                                    <span className="user-status"></span>
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="overflow-hidden d-flex flex-column">
                        <p className="text-truncate mb-0 fs-6">{displayName}</p>
                        <p className="text-truncate mb-0 fs-7">
                            {user.lastMessagePreview}
                        </p>
                    </div>
                    {unRead && unRead !== 0 ? (
                        <div className="ms-auto">
                            <span className="bg-light badge badge-soft-dark rounded p-1">
                                {unRead}
                            </span>
                        </div>
                    ) : null}
                </div>
            </Link>
        );
        return ref ? (
            <li
                ref={ref}
                className={classnames({ active: isSelectedChat })}
                onClick={onClick}
            >
                {chatUserContent}
            </li>
        ) : (
            <li
                className={classnames({ active: isSelectedChat })}
                onClick={onClick}
            >
                {chatUserContent}
            </li>
        );
    }
);

export default ChatUser;
